<div class="reset-password-page">
  <div class="card">
    <div class="brand">
      <img src="/assets/logo-horizontal.svg" alt="Waitora" class="brand-icon" />
    </div>

    <h1>{{ 'auth.resetPassword.title' | translate }}</h1>

    <div class="success" *ngIf="success">
      {{ 'auth.resetPassword.successMessage' | translate }}
    </div>

    <div class="error" *ngIf="apiError">{{ apiError }}</div>

    <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="!success && token">
      <label class="label">{{ 'auth.resetPassword.passwordLabel' | translate }}</label>
      <input
        class="input"
        type="password"
        formControlName="password"
        placeholder="••••••••"
        autocomplete="new-password"
      />
      <div class="error" *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
        {{ 'auth.resetPassword.passwordInvalid' | translate }}
      </div>

      <label class="label">{{ 'auth.resetPassword.confirmPasswordLabel' | translate }}</label>
      <input
        class="input"
        type="password"
        formControlName="confirmPassword"
        placeholder="••••••••"
        autocomplete="new-password"
      />
      <div class="error" *ngIf="form.get('confirmPassword')?.touched && form.get('confirmPassword')?.invalid">
        {{ 'auth.resetPassword.confirmPasswordInvalid' | translate }}
      </div>

      <button
        class="btn primary"
        type="submit"
        [disabled]="loading || form.invalid"
      >
        {{ loading ? ('auth.resetPassword.submitLoading' | translate) : ('auth.resetPassword.submit' | translate) }}
      </button>
    </form>

    <div *ngIf="!token && !success">
      <p>{{ 'auth.resetPassword.invalidToken' | translate }}</p>
      <button class="btn secondary" (click)="router.navigateByUrl('/login')">
        {{ 'auth.resetPassword.backToLogin' | translate }}
      </button>
    </div>
  </div>
</div>